export enum Permission {
  ItemPriceManagementView = 'item_price_management.view',
  ItemPriceManagementModify = 'item_price_management.modify',
  ItemPriceManagementDeleteChangeRequest = 'item_price_management.delete_change_request',
  ItemPriceManagementApprove = 'item_price_management.approve',
}
